import calendarIcon from "../../assets/icons/calendar.svg";
import { useInput } from "../../hooks/use-input";
import CustomButton from "../../components/Buttons/CustomButton";
import SearchBar from "../../components/common/SearchBar";
import DateRangePicker from "../../components/Form/DateRangePicker";

const DownloadsFilter = ({ onApply }) => {
  const {
    value: startDate,
    handleInputChange: handleStartDateChange,
    handleInputBlur: handleStartDateBlur,
    reset: resetStartDate,
  } = useInput("", () => "");

  const {
    value: endDate,
    handleInputChange: handleEndDateChange,
    handleInputBlur: handleEndDateBlur,
    reset: resetEndDate,
  } = useInput("", () => "");

  const {
    value: search,
    handleInputChange: handleSearchChange,
    reset: resetSearch,
  } = useInput("", () => "");

  const applyFilters = () => {
    onApply({
      startDate,
      endDate,
      search,
    });
  };

  const clearFilters = () => {
    resetStartDate();
    resetEndDate();
    resetSearch();
    onApply({
      startDate: "",
      endDate: "",
      search: "",
    });
  };

  // Check if the browser is Safari
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  return (
    <div className="w-full bg-[#111111d6] border border-[#505050] rounded-[8px] p-5 mb-6">
      <h2 className="text-[#E3E3E3] font-['Public Sans'] font-bold text-[20px] leading-[22px] mb-5">
        Filters
      </h2>
      <div className="flex flex-col md:flex-row gap-4 items-end justify-between w-full">
        {/* Date Range */}
        {/* <div className="flex flex-col gap-2 w-[262px]"> */}
        <div className="flex flex-col gap-2 w-full md:w-[262px]">
          <label className="text-[#E3E3E3] text-[14px] leading-[22px] font-['Public Sans']">
            Date Range
          </label>
          {/* <div className="flex items-center gap-[10px] bg-[#45444433] border border-[#808080] rounded-[5px] px-3 py-[10px]"> */}

          {isSafari ? (
             <DateRangePicker
              value={[startDate || null, endDate || null]}
              onChange={(dates) => {
                const [start, end] = dates;
                handleStartDateChange({ target: { value: start } });
                handleEndDateChange({ target: { value: end } });
              }}
              placeholder={["dd/mm/yyyy", "dd/mm/yyyy"]}
              outerContainerStyle="w-full"
            />
          ) : (
            <div className="flex flex-row gap-2 bg-[#45444433] border border-[#808080] rounded-[5px] px-3 py-[10px]">
            {/* Start Date */}
            <div className="relative w-1/2">
              <input
                type="date"
                name="startDate"
                value={startDate}
                onChange={handleStartDateChange}
                onBlur={handleStartDateBlur}
                className="custom-date w-full bg-transparent text-[14px] leading-[22px] font-['Public Sans'] text-[#B6B6B6CC] pr-6 outline-none placeholder-[#B6B6B6CC] cursor-pointer"
              />
              <img
                src={calendarIcon}
                alt="calendar"
                className="absolute right-[4px] top-1/2 transform -translate-y-1/2 w-[14px] h-[14px] pointer-events-none"
              />
            </div>

            {/* End Date */}
            {/* <div className="relative min-w-[110px]  w-full"> */}
            <div className="relative w-1/2">
              <input
                type="date"
                name="endDate"
                value={endDate}
                onChange={handleEndDateChange}
                onBlur={handleEndDateBlur}
                className="custom-date w-full bg-transparent text-[14px] leading-[22px] font-['Public Sans'] text-[#B6B6B6CC] pr-6 outline-none placeholder-[#B6B6B6CC] cursor-pointer"
              />
              <img
                src={calendarIcon}
                alt="calendar"
                className="absolute right-[4px] top-1/2 transform -translate-y-1/2 w-[14px] h-[14px] pointer-events-none"
              />
            </div>
          </div>
          )}
        </div>

        {/* <div className="min-w-[506px] w-full h-[71px]"> */}
        <div className="w-full md:w-[626px] h-[71px]">
          <label className="text-[#E3E3E3] text-[14px] font-['Public Sans'] block mt-[-4px] mb-[8px]">
            Search
          </label>
          <div className="relative w-full h-[45px]">
            <SearchBar
              searchQuery={search}
              setSearchQuery={(val) =>
                handleSearchChange({ target: { value: val } })
              }
              setRefreshTrigger={() => {}}
              placeholder="Search tracks or artists..."
              containerClass="w-full h-full bg-[#45444433] border border-[#808080a3] rounded-[5px] pl-[35px] pr-[60px] flex items-center mt-1"
              inputClass="bg-transparent text-[14px] font-['Public Sans'] text-[#B6B6B6A3] outline-none w-full h-full"
              buttonClass="absolute right-[95px] top-[12px] text-[#A0A0A0] hover:text-white text-lg font-bold"
              iconClass="absolute left-[12px] top-[14px] w-[15px] h-[15px]"
              closeIconClass="w-[14px] h-[14px]"
            />
            <button
              onClick={applyFilters}
              className="absolute right-[2px] top-[1px] w-[60px] h-[43px] bg-[#272727] rounded-[4px] flex items-center justify-center text-[11px] text-[#979798] uppercase font-['Public Sans']"
            >
              Search
            </button>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex flex-row gap-3 w-full">
          <CustomButton
            useGradientBorder
            className="min-w-[136px] w-full h-[42px] text-[18px] font-semibold font-['Public_Sans'] py-0 px-0"
            textColor="text-[#51F9EF]"
            gradient="bg-gradient-to-b from-[#51F9EF] to-[#1A7DD1]"
            onClick={applyFilters}
          >
            Apply Filters
          </CustomButton>
          <CustomButton
            className="min-w-[103px] h-[42px] text-[14px] font-normal font-inter py-0 px-0 uppercase"
            textColor="text-[#9FB0AF]"
            borderColor="border-[#9FB0AF]"
            onClick={clearFilters}
          >
            Clear All
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default DownloadsFilter;
